<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7waqnv/tc-custom/9781504061957.jpg?1703216932541" alt="This image is the cover for the book South Sea Tales"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">South Sea Tales
      </h1>
      <p class="bookDescription body article font2">
        <b>Eight tropical tales set in different regions of the South Pacific</b><b>by the renowned nineteenth-century author of <i>The Call of the Wild</i> and <i>White Fang</i>.</b><br/>  <br/> These stories, like his renowned <i>Klondike Tales</i>, are based on Jack London’s own travels and adventures. Including such stories as “The House of Mapuhi,” “The Whale Tooth,” and “The Inevitable White Man,” this collection describes the beauties and dangers of the South Pacific as colonist ships explore the islands.<br/>  <br/> “All in all, if you like nautical and sea adventures, if you are interested in the history of the Pacific Islands, or if you want to read gripping tales set in the exotic lands, this book will be perfect for you. But remember—it is definitely not a piece of light-hearted literature!” —Tales from Pasifika
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack London
      </h2>
      
      <p class="authorDescription body article">Born in San Francisco, Jack London (1876&ndash;1916) shoveled coal, pirated oysters, sailed with a sealing schooner, and worked in a cannery as a youth. In 1897, London traveled to the Yukon to join the Klondike gold rush, an experience that inspired many of his later works. Best known for <I>The Call of the Wild </I>(1903), he wrote and published more than fifty volumes of essays, novels, and short stories, and was one of the most popular authors of his era.&#160;<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cafab5a